import React from 'react'
import { Link } from 'react-router-dom'
import V2Layout from '../components/V2Layout'
import SEO from '../components/SEO'
import useCompanyStats from '../components/useCompanyStats'
import { CAPABILITIES_SECTIONS } from './capabilities/capabilitiesData'
import '../versions/v2/capabilities.css'

const CapabilitiesScreen = () => {
    const { stats } = useCompanyStats()
    return (
        <V2Layout pageClass="pfc-capabilities">
            <SEO
                title="Capabilities"
                description="From custom-designed components to lights-out machining of hard alloys, PFC delivers precision hardware for the world's most demanding applications in aerospace, launch vehicle, and defense programs."
            />
            {/* Hero */}
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Manufacturing Capabilities</p>
                    <h1 className="pfc-page-hero-title">Built for Extreme Environments</h1>
                    <p className="pfc-page-hero-sub">
                        From custom-designed components to lights-out machining of hard alloys, PFC delivers precision hardware for the world's most demanding applications. Our products serve aerospace, launch vehicle, and defense programs — all produced under one roof in Lincoln, California.
                    </p>
                    <p className="pfc-page-hero-sub visually-hidden">
                        See the <Link to="/aerospace-valves">valve types, applications, and certifications</Link> behind our aerospace hardware.
                    </p>
                </div>
            </section>

            {/* Stats bar */}
            <section className="v2-stats-bar">
                <div className="v2-stats-inner">
                    <div className="v2-stat">
                        <span className="v2-stat-num">{stats.cnc_total}</span>
                        <span className="v2-stat-label">CNC Work Centers</span>
                    </div>
                    <div className="v2-stat">
                        <span className="v2-stat-num">{stats.facility_size}</span>
                        <span className="v2-stat-label">Sq Ft Facility</span>
                    </div>
                    <div className="v2-stat">
                        <span className="v2-stat-num">{new Date().getFullYear() - parseInt(stats.year_founded)}+</span>
                        <span className="v2-stat-label">Years in Service</span>
                    </div>
                    <div className="v2-stat">
                        <span className="v2-stat-num">AS9100D</span>
                        <span className="v2-stat-label">Certified</span>
                    </div>
                </div>
            </section>

            {/* Explore all capabilities */}
            <section className="cap-section">
                <div className="cap-section-inner">
                    <div className="cap-section-header">
                        <h2 className="cap-title">Explore All Capabilities</h2>
                    </div>
                    <div className="cap-cards-3">
                        {CAPABILITIES_SECTIONS.map(s => (
                            <Link to={`/capabilities/${s.slug}`} key={s.slug} className="cap-card cap-card--explore" style={{ textDecoration: 'none' }}>
                                <div className="cap-card-head">
                                    <span className="cap-card-icon-box"><i className={`ti ${s.icon}`}></i></span>
                                    <h3 className="cap-card-title">{s.shortTitle}</h3>
                                </div>
                                <p className="cap-card-body">View details →</p>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </V2Layout>
    )
}

export default CapabilitiesScreen
